import { Autocomplete, Checkbox, Paper, TextInput } from '../../common/Form'
import { AdInsertionCompatibility } from '../../common/AdInsertionCompatibility'
import { AdServer } from 'common/types'
import { AdPodSelector } from './AdPodSelector'
import { AdNumberFilterInputField } from './AdNumberFilterInputField'
import { useCallback } from 'react'
import { Api, GlobalState } from '../../../store'
import { shallowEqual, useSelector } from 'react-redux'
import type { AllowUncontrolled, FormProps } from '../../common/Form/RHF'
import type { EnrichedOutputWithEnrichedPorts } from './index'
import { useWatch } from 'react-hook-form'

interface Props {
  form: FormProps<EnrichedOutputWithEnrichedPorts & AllowUncontrolled>
}

export const AdInsertionSection = ({ form }: Props) => {
  const { getValues } = form
  const values = getValues()

  useWatch({ name: 'adInsertionEnabled' })
  useWatch({ name: '_externalAdServer' })

  const adServersApi = useCallback(Api.adServersApi.listAdServers.bind(Api.adServersApi), [])
  const selectedAdServer = useSelector(
    ({ adInsertionReducer }: GlobalState) => adInsertionReducer.selectedAdServer,
    shallowEqual,
  )

  return (
    <Paper
      id="ad-insertion-section"
      className="outlined"
      title="Ad Insertion"
      collapsible
      collapsed={!values.adInsertionEnabled}
    >
      <Paper>
        {Array.isArray(values.tsInfo) && values.tsInfo.length > 0 && (
          <AdInsertionCompatibility latestTsInfo={values.tsInfo[0]} />
        )}
        <Checkbox name="adInsertionEnabled" label="Enabled" />
        <Checkbox name="_externalAdServer" label="Use External Ad Server" />

        {values._externalAdServer ? (
          <>
            <Autocomplete<AdServer>
              name="adServer"
              label="Ad Server"
              required={values.adInsertionEnabled}
              api={adServersApi}
              defaultOption={values.adServer && selectedAdServer ? selectedAdServer : undefined}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.name}
              optionComparator={(o1, o2) => o1.id === o2.id}
              disabled={!values.adInsertionEnabled}
              xs={4}
              newLine
            />
            <TextInput
              name="adUrl"
              label="Ad Server Template URL"
              disabled={!values.adInsertionEnabled}
              tooltip={'Part of the ad server URL that is specific to this output'}
            />
          </>
        ) : (
          <AdPodSelector
            formName={'adPod'}
            required={values.adInsertionEnabled}
            adPodId={values.adPod || undefined}
            newLine
          />
        )}

        <AdNumberFilterInputField formName={'scteEventIdFilter'} label={'SCTE 35 Event ID Filter'} newLine />
        <AdNumberFilterInputField formName={'sctePidFilter'} label={'SCTE 35 PID Filter'} />
      </Paper>
    </Paper>
  )
}
